function getSwitchingStateBtn(switching_status) {
    return switching_status === "successful";
}

export default getSwitchingStateBtn;